import { useMemo } from 'react';

import { RewardPool, RewardPoolTicketCurrency } from '@shared/api/types/rewardPools';
import { useRewardPoolSelfEntries } from '@shared/hooks/query/rewardPools';

import { DialogProps } from '@radix-ui/react-dialog';
import { TicketsListSkeleton } from '@store:web/components/entities/rewardPool';
import { CustomDialog, DialogCancelButton } from '@ui/uikit/components/common/Dialog';

import { TicketsList } from './TicketsList';
import { TicketListItemType } from './TicketsListItem';

type Props = DialogProps & {
  rewardPool: RewardPool;
  closeModal: () => void;
  currency: RewardPoolTicketCurrency;
};

export const ViewTicketsModal = ({ rewardPool, closeModal, currency, ...props }: Props) => {
  const { data: entries = [], isLoading } = useRewardPoolSelfEntries(rewardPool.id);

  const filteredByCurrencyEntries: TicketListItemType[] = useMemo(() => {
    return entries
      .filter((entry) => entry.currency === currency)
      .map((entry) => {
        return {
          isWinner: Boolean(entry.reward),
          code: entry.id,
        };
      });
  }, [entries, currency]);

  return (
    <CustomDialog
      {...props}
      title={`My Tickets in ${rewardPool.name}`}
      titleIsLeftAligned
      noSidePadding
      size="md"
      footer={<DialogCancelButton className="!w-[220px] max-sm">Close</DialogCancelButton>}
    >
      {isLoading ? (
        <TicketsListSkeleton />
      ) : (
        <div className="h-[500px] max-h-[55vh]">
          <TicketsList
            className="py-6 px-4"
            tickets={filteredByCurrencyEntries}
            isLoading={isLoading}
          />
        </div>
      )}
    </CustomDialog>
  );
};
